"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.number.constructor");

var _vueCountTo = _interopRequireDefault(require("vue-count-to"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'AgentCardInfo',
  props: {
    loadingInfo: Boolean,
    value: Number,
    label: String,
    iconColor: String,
    icon: String,
    cardKey: Number
  },
  components: {
    CountTo: _vueCountTo.default
  }
};
exports.default = _default;